'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'rainbow';
var width = 640;
var height = 512;
var aliases = [127752];
var unicode = 'f75b';
var svgPathData = ['M8 480c4.4 0 8-3.6 8-8l0-120C16 184.1 152.1 48 320 48s304 136.1 304 304l0 120c0 4.4 3.6 8 8 8l-88 0c4.4 0 8-3.6 8-8l0-112c0-128.1-103.9-232-232-232S88 231.9 88 360l0 112c0 4.4 3.6 8 8 8L8 480zm88 0c4.4 0 8-3.6 8-8l0-112c0-119.3 96.7-216 216-216s216 96.7 216 216l0 112c0 4.4 3.6 8 8 8l-104 0c4.4 0 8-3.6 8-8l0-120c0-70.7-57.3-128-128-128s-128 57.3-128 128l0 120c0 4.4 3.6 8 8 8L96 480z', 'M320 48C152.1 48 16 184.1 16 352l0 120c0 4.4-3.6 8-8 8s-8-3.6-8-8L0 352C0 175.3 143.3 32 320 32s320 143.3 320 320l0 120c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-120C624 184.1 487.9 48 320 48zm0 192c-61.9 0-112 50.1-112 112l0 120c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-120c0-70.7 57.3-128 128-128s128 57.3 128 128l0 120c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-120c0-61.9-50.1-112-112-112zM104 360l0 112c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-112c0-128.1 103.9-232 232-232s232 103.9 232 232l0 112c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-112c0-119.3-96.7-216-216-216s-216 96.7-216 216z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;